import { render, staticRenderFns } from "./UserTrendUserIcon.vue?vue&type=template&id=6b3e3470&scoped=true"
import script from "./UserTrendUserIcon.vue?vue&type=script&lang=ts"
export * from "./UserTrendUserIcon.vue?vue&type=script&lang=ts"
import style0 from "./UserTrendUserIcon.vue?vue&type=style&index=0&id=6b3e3470&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3e3470",
  null
  
)

/* custom blocks */
import block0 from "@/i18n/components/user-trend/table/user-trend-user-icon.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusergram-front%2Fsrc%2Fcomponents%2Fuser-trend%2Ftable%2FUserTrendUserIcon.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports